import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Outlet, useLocation } from "react-router-dom";
import { checkPermission } from "../../helpers/GeneralHelper";
import Error403 from './Error403';

function Permission() {
  const location = useLocation();

  let lastPos = location.pathname.indexOf('/', 1);
  let route = '';
  if (lastPos == -1) {
    route = location.pathname.slice(1);
  } else {
    route = location.pathname.slice(1, lastPos);
  }

  // Credit notes use the same role permissions as invoices
  if (route === "credit-notes") {
    route = "invoices";
  }

  if (checkPermission(route)) {
    return <Outlet />
  }

  return <Error403 />;
}

export default Permission;
